import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { Instance } from 'src/app/models/instance/instance';
import { BlueprintVersion } from 'src/app/models/blueprints/blueprint-version';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { EnvironmentPaginatorrModule } from '../environment-details/environment-paginator/environment-paginator.module';
import { MatSort } from '@angular/material/sort';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { translate, TranslocoModule } from '@jsverse/transloco';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { AuthService } from 'src/app/services/auth/auth.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { EnvironmentTableModule } from '../environment-details/environment-table/environment-table.module';
import { VersionDetailsPopupComponent } from 'src/app/main/blueprint-summary/version-details-popup/version-details-popup.component';
import { DeploySizingComponentModule } from '../blueprint-summary/deploy-sizing/deploy-sizing.module';
import { SizingStatus } from '../blueprint-summary/deploy-sizing/deploy-sizing.component';
import { SizingService } from 'src/app/services/api/sizing.service';
import { SizingProgressDialogComponent } from 'src/app/components/sizing-progress-dialog/sizing-progress-dialog.component';
import { SizingProgressDialogModule } from 'src/app/components/sizing-progress-dialog/sizing-progress-dialog.module';
import { ServiceDefinitionStepComponent } from './service-definition-step/service-definition-step.component';
import { FormsModule } from '@angular/forms';
import { MonacoEditorModule } from '@vality/ng-monaco-editor';
import { SizingContentComponent, SizingViewMode } from 'src/app/components/sizing-content/sizing-content.component';
import { SizingConfirmDialogComponent } from 'src/app/components/sizing-confirm-dialog/sizing-confirm-dialog.component';
import { SizingDialogMode } from 'src/app/models/sizing';
import {SizingErrorUtil} from 'src/app/services/util/sizing-error.util'
import { JsonValidationService } from 'src/app/services/util/json-validation.service';
import { sizingTemplateSchema } from 'src/app/schemas/sizingTemplate-schema';

@Component({
    selector: 'app-update-service-definition-creation',
    templateUrl: './update-service-definition-creation.component.html',
    styleUrls: ['./update-service-definition-creation.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        MatDividerModule,
        SearchFilterModule,
        EnvironmentPaginatorrModule,
        IconsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        BreadcrumbModule,
        RouterLink,
        EnvironmentTableModule,
        DeploySizingComponentModule,
        SizingProgressDialogModule,
        ServiceDefinitionStepComponent,
        FormsModule,
        MonacoEditorModule,
        SizingContentComponent
    ]
})
export class UpdateServiceDefinitionCreation  implements OnInit {
  private destroyRef = inject(DestroyRef);
  @ViewChild(MatSort, {static: true}) sort;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() instance: Instance;
  @Input() serviceName: string;
  tenantId: any;
  blueprintId: number;
  blueprint: any;
  errorPageService: any;
  instanceData: any;
  allSizingRecords: any[];
  sizingTableData: any;
  isLoading = true;
  /** Sets available blueprint configurations, sorts them by date descending. */
  @Input() set availableConfigurations(availableConfigurations: BlueprintVersion[]) {
    this.blueprintsVersionList = availableConfigurations !== undefined ? [...availableConfigurations] : [];
    this.blueprintsVersionList.sort(this.defaultComparator);
  }

  @Input() blueprintsVersionList: BlueprintVersion[];
  deployedVersion: string;
  Constants = Constants;
  RouterSegments = RouterSegments;
  selection: BlueprintVersion;
  expandedRows: KeyValueMap<string, boolean> = {};

  pageConfigurations: BlueprintVersion[];
  filteredConfigurations: BlueprintVersion[];

  ascendingOrder = false;
  breadcrumbItems: BreadcrumbItem[] = [];

  // Stepper management
  currentStep: 'serviceDefinition' | 'sizing' = 'serviceDefinition';

  // Sizing properties
  SizingStatus = SizingStatus;
  sizingStatus: SizingStatus = SizingStatus.NOT_STARTED;
  sizingCreatedDate?: string;
  sizingCreatedBy?: string;
  sizingCards: any[] = [];
  isSizingLoading = false;
  isGlobalLoading = false;
  currentView: SizingViewMode = SizingViewMode.FORM;
  sizingSearchTerm: string = '';
  originalSizingCards: any[] = [];
  sizingDocumentName?: string;
  sizingDocumentId?: string;
  editorOptions = {
    theme: 'light',
    language: 'json',
    automaticLayout: true,
    readOnly: true,
  };
  jsonInput = {
    value: '',
    language: 'json'
  };
  isJsonLoading = false;
  validSchema: boolean;
  templateResponse = true;
  errorsWithComponent : any;
  retrySizing = false;


  // Environment table properties
  tableData: any[] = [];
  displayColumns: any[] = [];
  searchTerm = '';
  showTable = false;
  dataLoading = false;

  // Pagination properties
  pageIndex = 0;
  paginationSize = 10;
  paginatedTableData: any[] = [];
  

  // Sizing view mode
  SizingViewMode = SizingViewMode;

  constructor(
    public sidenavService: SidenavService,
    private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog,
    private toastrService: CustomToastrService,
    private router: Router,
    public location: Location,
    private instanceService: InstancesService,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public blueprintsService: BlueprintsService,
    private sizingService: SizingService,
    private jsonSchemaValidator: JsonValidationService,
    private dialog: MatDialog,
  ) {
    // Get data from router state
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      const state = navigation.extras.state;
      this.instance = state['instance'];
      this.title = state['title'];
      this.subtitle = state['subtitle'];
      this.serviceName = state['serviceName'];
      this.blueprintsVersionList = state['blueprintsVersionList'];
      this.deployedVersion = state['deployedVersion'];
    }
  }

  /** Initializes the component: resolves route params, builds breadcrumbs, loads instance data, blueprint, and versions. */
  ngOnInit(): void {
    if (!this.instance) {
      this.tenantId = this.activatedRoute.snapshot.parent.params.id;
      this.blueprintId = this.activatedRoute.snapshot.parent.params.blueprintId;

      this.router.navigate([
        '/',
        this.authService.principal.provider,
        RouterSegments.TENANT,
        this.tenantId,
        RouterSegments.SERVICE_DEFINITION,
        this.blueprintId
      ]);
      return;
    }

    this.tenantId = this.activatedRoute.snapshot.parent.params.id;
    this.blueprintId = this.activatedRoute.snapshot.parent.params.blueprintId;
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg', url:[RouterSegments.TENANT, this.tenantId] });
    this.breadcrumbItems.push({label: translate('TENANT_LAYOUT.MENU.SERVICE_DEFINITION'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION]});
    this.instanceService.getInstanceById(this.instance.id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(
                (data: any) => {
                  this.instanceData = data;
                });
    this.loadBlueprint();
    this.initializeTableColumns();
    if (!this.blueprintsVersionList || this.blueprintsVersionList.length === 0) {
      this.loadBlueprintVersions();
    } else {
      this.prepareTableData();
      this.search();
    }
  }

  /** Fetches all versions for the current blueprint from the API and populates the table. */
  loadBlueprintVersions(): void {
    this.dataLoading = true;
    this.blueprintsService.getBlueprintVersion(this.blueprintId.toString())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (versions: any) => {
          this.blueprintsVersionList = Array.isArray(versions) ? versions : [versions];
          this.dataLoading = false;
          this.prepareTableData();
          this.search();
        },
        error: (error) => {
          this.dataLoading = false;
          this.showTable = false;
        }
      });
  }

  /** Defines the column configuration for the blueprint versions table. */
  initializeTableColumns(): void {
    this.displayColumns = [
      { key: 'selected', name: '', type: 'radioSelection', visible: true },
      { key: 'version', name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.VERSION', type: 'text', sortable: true, visible: true },
      { key: 'dateCreated', name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DATE_GENERATED', type: 'date', sortable: true, visible: true },
      { key: 'status', name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.STATUS', type: 'status', visible: true }
    ];
  }

  /** Maps blueprint versions to table rows, computing status and disabling selections for older versions. */
  prepareTableData(): void {
    if (!this.blueprintsVersionList || this.blueprintsVersionList.length === 0) {
      this.tableData = [];
      this.filteredConfigurations = [];
      this.showTable = false;
      return;
    }

    this.tableData = this.blueprintsVersionList.map(blueprintVersion => ({
      ...blueprintVersion,
      version: String(blueprintVersion.version),
      status: this.getStatus(blueprintVersion),
      selected: false,
      arrowClick: false,
      disableSelection: Number(blueprintVersion.version) <= Number(this.deployedVersion) // Disable if version <= deployed
    }));

    this.filteredConfigurations = [...this.blueprintsVersionList];
    this.updatePaginatedData();
    this.showTable = true;
    this.changeDetectorRef.detectChanges();
  }

  /** Returns the display status label for a blueprint version relative to the currently deployed version. */
  getStatus(blueprintVersion: BlueprintVersion): string {
    if (Number(this.deployedVersion) === Number(blueprintVersion.version)) {
      return translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.DEPLOYED');
    } else if (Number(blueprintVersion.version) < Number(this.deployedVersion)) {
      return translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE');
    } else {
      return translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.AVAILABLE');
    }
  }

  /** Loads the blueprint details and appends its name to the breadcrumb trail. */
  private loadBlueprint(): void {
    this.isLoading = true;
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprints => {
        this.isLoading = false;
        this.blueprint = blueprints.find((item: any) => item.id === this.blueprintId);
        this.breadcrumbItems.push({label: this.blueprint?.name});
      }, (error) => {
        this.isLoading = false;
        this.errorPageService.show404Page()
      });
  }

  /** Filters blueprint versions by the given search value; resets to full list if no value is provided. */
  search(value?: string): void {
    if(value) {
      const searchValue = value.toLowerCase();
      this.filteredConfigurations = this.blueprintsVersionList.filter(config =>
        config.version.toLowerCase().includes(searchValue) ||
        this.serviceName.toLocaleLowerCase().includes(searchValue));
    } else {
      this.filteredConfigurations = this.blueprintsVersionList;
    }

    if (this.selection && !this.filteredConfigurations.includes(this.selection)) {
      this.selection = null;
    }
  }

  /** Sets the selected blueprint version row. */
  select(row): void {
    this.selection = row;
  }

  /** Toggles the expanded/collapsed state of a blueprint version row. */
  expandRow(blueprintsVersionList: BlueprintVersion): void {
    this.expandedRows[blueprintsVersionList.id] = !this.expandedRows[blueprintsVersionList.id];
  }

  /** Opens the version details popup for the clicked blueprint version. */
  onVersionClick(data: any): void {
    this.matDialog.open(VersionDetailsPopupComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        blueprintVersion: data,
        instance: this.instance
      }
    });
  }

  /** Advances to the sizing step after confirmation; loads existing sizing doc or starts a fresh sizing process. */
  nextStep(): void {
    if (this.currentStep === 'serviceDefinition' && this.selection) {
      const hasExistingSizing = this.instanceData?.sizingDocumentId;
          this.currentStep = 'sizing';
          if (hasExistingSizing) {
            this.loadExistingSizingDocumentWithProgress(this.instanceData.sizingDocumentId);
          } else {
            this.startSizingProcess();
          }
        }
    }

  /** Opens a progress dialog and begins loading an existing sizing document by ID. */
  private loadExistingSizingDocumentWithProgress(sizingDocumentId: string): void {
    this.isGlobalLoading = true;
    this.isSizingLoading = true;

    const dialogRef = this.matDialog.open(SizingProgressDialogComponent, {
      width: '566px',
      height: '225px',
      disableClose: true,
      data: {
       title: translate('SIZING.VALIDATE'),
       progress: 0,
       showCount:false
      }
    });

    this.loadExistingSizingDocument(sizingDocumentId, dialogRef);
  }

  /** Builds the request payload for creating a new sizing document from current sizing cards. */
  private buildSizingPayload(): any {
    return {
      id: this.instance.id,
      name: this.sizingDocumentName,
      environmentSize: "xxs-small",
      blueprintVersionId: this.selection?.id,
      components: this.sizingCards.map(card => ({
        component: card.component,
        document: this.buildComponentDocument(card)
      }))
    };
  }

  /** Converts a sizing card's sections and metrics into a flat document object keyed by section title. */
  private buildComponentDocument(card: any): any {
    if (!card?.sections?.length) {
      return {};
    }
    const document: any = {};
    card.sections.forEach((section: any) => {
      if (!section?.metrics?.length) return;
      const sectionObject: any = {};
      section.metrics.forEach((metric: any) => {
        if (!metric?.key && !metric?.label) return;
        const key = metric.key || metric.label.toLowerCase().replace(/ /g, '_');
        sectionObject[key] = metric.value;
      });
      document[section.sectionTitle] = sectionObject;
    });
    return document;
  }

  /** Initiates the sizing generation process and shows a progress dialog while loading sizing template data. */
  private startSizingProcess(): void {
    this.sizingStatus = SizingStatus.IN_PROGRESS;
    this.isSizingLoading = true;
    this.isGlobalLoading = true;

    const dialogRef = this.matDialog.open(SizingProgressDialogComponent, {
      width: '566px',
      height: '225px',
      disableClose: true,
      data: {
        title: translate('SIZING.VALIDATE'),
        processed: 0,
        showCount:false
      }
    });
    this.loadSizingData(dialogRef);
  }

  /** Navigates back to the service definition step from the sizing step. */
  previousStep(): void {
    if (this.currentStep === 'sizing') {
      this.currentStep = 'serviceDefinition';
    }
  }

/** Fetches the sizing template for the selected blueprint version and progressively builds sizing cards, invoking the optional callback when done. */
loadSizingData(dialogRef?: any, onSizingCardsBuilt?: (sizingCards: any[]) => void): void {
  this.isSizingLoading = true;
  this.isGlobalLoading = true;

  const blueprintVersionId = this.selection?.id;

  let progress = 0;

  const progressInterval = setInterval(() => {
    if (dialogRef?.componentInstance && progress < 90) {
      progress += 1;
      dialogRef.componentInstance.progress = progress;
    }
  }, 300);

  this.sizingService
    .getSizingTemplateByInstanceId(this.instanceData?.id, blueprintVersionId, 'xxs-small')
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({

      next: (response: any) => {
        this.templateResponse = response.length > 0 ? true : false;
        if (!Array.isArray(response) || !this.templateResponse) {
          this.sizingStatus = SizingStatus.FAILED;
          this.isSizingLoading = false;
          this.isGlobalLoading = false;
          dialogRef?.close();
          return;
        }

        const records = Array.isArray(response) ? response : [];
        const templateSchema = this.jsonSchemaValidator.validate(records,sizingTemplateSchema);
        this.validSchema = templateSchema.valid;

        if (templateSchema.valid) {
        clearInterval(progressInterval);
        if (dialogRef?.componentInstance) {
          dialogRef.componentInstance.progress = 100;
        }

          const validRecords = records.filter(record =>
            record?.template &&
            Object.keys(record.template).length > 0 &&
            record.template?.properties &&
            Object.keys(record.template.properties).length > 0
          );

          const total = validRecords.length;

          if (dialogRef?.componentInstance) {
            dialogRef.componentInstance.title = translate('SIZING.PREPARE');
            dialogRef.componentInstance.total = total;
            dialogRef.componentInstance.showCount = true;
          }

          let processed = 0;

          const processNext = () => {

            if (processed >= total) {

              dialogRef?.close();
              this.isSizingLoading = false;
              this.isGlobalLoading = false;

              this.sizingStatus = SizingStatus.COMPLETED;
              this.sizingCreatedDate = new Date().toISOString();
              this.sizingCreatedBy = this.authService.principal.name;

              if (onSizingCardsBuilt) {
                onSizingCardsBuilt(this.sizingCards);
              }

              return;
            }

            const record = validRecords[processed];

            if (dialogRef?.componentInstance) {
              dialogRef.componentInstance.currentComponent =
                record.component || record.componentDisplayName || '';

              dialogRef.componentInstance.processed = processed + 1;
            }
            const card = this.sizingService.buildSizingCards(record);
            this.originalSizingCards.push(card);
            this.sizingCards.push(card);
            processed++;

            setTimeout(processNext, 400);
          };

          processNext();
        } else {
          if (dialogRef) {
          dialogRef.close();
        }
        this.isSizingLoading = false;
        this.isGlobalLoading = false;
        this.sizingStatus = SizingStatus.FAILED;
        this.showErrorDialog(true, templateSchema,records);
        }

      },

      error: (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        clearInterval(progressInterval);
        this.retrySizing = true;
        this.sizingStatus = SizingStatus.FAILED;
        this.isSizingLoading = false;
        this.isGlobalLoading = false;

        dialogRef?.close();
      }
    });
}


  /** Returns true if the given step is the currently active step. */
  isActive(step: 'serviceDefinition' | 'sizing'): boolean {
    return this.currentStep === step;
  }

  /** Returns true if the given step has been completed. */
  isCompleted(step: 'serviceDefinition' | 'sizing'): boolean {
    if (step === 'sizing' && this.sizingDocumentId) {
      return this.sizingStatus === SizingStatus.COMPLETED;
    }
    return this.currentStep !== 'serviceDefinition' && step === 'serviceDefinition';
  }

  /** Returns true if the sizing step has failed. */
  isFailed(step: 'serviceDefinition' | 'sizing'): boolean {
    if (step === 'sizing') {
      return this.sizingStatus === SizingStatus.FAILED;
    }
    return false;
  }

  /** Fetches a saved sizing document by ID and patches its stored values onto the current sizing cards. */
  patchExistingSizingValues(sizingDocumentId: string, dialogRef?: any): void {
    if (!this.instanceData?.id) {
      return;
    }
    this.sizingService.getSizingDocsById(this.instanceData.id, sizingDocumentId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response && response.components) {
            // Patch saved values onto existing sizing cards
            response.components.forEach((comp: any) => {
              const matchingCard = this.sizingCards.find((card: any) => card.component === comp.component);

              if (matchingCard && comp.document) {
                Object.keys(comp.document).forEach(sectionKey => {
                  const savedSectionData = comp.document[sectionKey];
                  const matchingSection = matchingCard.sections?.find((s: any) => s.sectionTitle === sectionKey);

                  if (matchingSection && savedSectionData) {
                    matchingSection.metrics?.forEach((metric: any) => {
                      const metricKey = metric.key || metric.label.toLowerCase().replace(/ /g, '_');
                      if (savedSectionData[metricKey] !== undefined) {
                        metric.value = savedSectionData[metricKey];
                      }
                    });
                  }
                });
              }
            });

            // Update metadata and status
            this.sizingStatus = SizingStatus.COMPLETED;
            this.sizingCreatedDate = response.createdAt;
            this.sizingCreatedBy = response.createdBy;
            this.sizingDocumentName = response.name;

            this.originalSizingCards = [...this.sizingCards];

            // Close progress dialog if provided
            if (dialogRef) {
              setTimeout(() => {
                dialogRef.close();
                this.isSizingLoading = false;
                this.isGlobalLoading = false;
              }, 500);
            }

            this.changeDetectorRef.detectChanges();
          }
        },
        error: (error) => {
          this.sizingStatus = SizingStatus.FAILED;

          // Close progress dialog if provided
          if (dialogRef) {
            dialogRef.close();
            this.isSizingLoading = false;
            this.isGlobalLoading = false;
          }
        }
      });
  }

  /** Loads the sizing template data first, then patches in values from the existing sizing document. */
  loadExistingSizingDocument(sizingDocumentId: string, dialogRef?: any): void {
    if (!this.instanceData?.id) {
      if (dialogRef) {
        dialogRef.close();
      }
      return;
    }
    this.loadSizingData(dialogRef, (sizingCards) => {
      this.patchExistingSizingValues(sizingDocumentId, dialogRef);
    });
  }


  /** Prompts the user for a document name, then submits the sizing document to the API. */
  applyConfiguration(): void {
    this.sizingService.getSizingDocs(this.instance.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(response => {
            response = response?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
            this.sizingTableData = response;

            const existingNames = (this.sizingTableData || []).map((d: any) => d?.name?.toLowerCase().trim());
            const generatedName = this.generateNextSizingName(existingNames);

            const dialogRef = this.matDialog.open(SizingConfirmDialogComponent, {
              width: '566px',
              height: '306px',
              disableClose: true,
              data: {
                documentName: generatedName,
                disableName: true,
                environmentSize: null,
                mode: SizingDialogMode.SUBMIT
              }
            });

            dialogRef.afterClosed()
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((result: any) => {
                if (!result?.documentName) return;

                this.sizingDocumentName = result?.documentName;
                const payload = this.buildSizingPayload();

                this.sizingStatus = SizingStatus.IN_PROGRESS;

                this.sizingService
                  .postSizingDocs(payload)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe({
                    next: (response) => {
                      this.sizingDocumentId = response?.id;

                      if (!this.sizingDocumentId) {
                        this.sizingStatus = SizingStatus.FAILED;
                        return;
                      }

                      // Set status to COMPLETED and update metadata
                      this.sizingStatus = SizingStatus.COMPLETED;
                      this.sizingCreatedDate = response?.createdAt || new Date().toISOString();
                      this.sizingCreatedBy = response?.createdBy || this.authService.principal.name;

                      // Show success message
                      const title = translate('SIZING.SIZING_TITLE');
                      const message = translate('SIZING.DOCUMENT_CREATED');
                      this.toastrService.successMessage(message, title);

                      // Trigger change detection to update stepper display
                      this.changeDetectorRef.detectChanges();
                    },
                    error: (error) => {
                      this.sizingStatus = SizingStatus.FAILED;

                      // Show error dialog
                      const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
                      this.matDialog.open(ErrorDialogComponent, {
                        minHeight: '342px',
                        width: '566px',
                        panelClass: 'flex-dialog',
                        data: {
                          title: translate('NOTIFICATIONS.SIZING_FAILED'),
                          description: errorMessage,
                        }
                      });
                    }
                  });
              });
          });
  }

  /** Opens a confirmation dialog then applies the selected blueprint version to the instance and navigates back on success. */
  applyServiceDefinition(): void {
    const selectedConfiguration = this.selection;
    this.matDialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_SERVICE_DEFINITION.NEW_TITLE'),
        message: translate('INSTANCE_DETAILS.UPDATE_SERVICE_DEFINITION.NEW_MESSAGE'),
        summary1: this.selection?.version,
        summary2: this.sizingDocumentName,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {

    // Apply the selected service definition
    this.instanceService.applyDefinition(selectedConfiguration.id, this.instance.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          // Show success message
          const title = translate('TENANT_DASHBOARD.INSTANCE');
          const message = translate('INSTANCE_DETAILS.UPDATE_SERVICE_DEFINITION.SERVICE_DEFINITION_SUCCESS');
          this.toastrService.successMessage(message, title);

          // Navigate back to the previous page
          setTimeout(() => {
            this.location.back();
          }, 500);
        },
        error: (error) => {
          // Handle error
          const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
          this.matDialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '566px',
            panelClass: 'flex-dialog',
            data: {
              title: translate('NOTIFICATIONS.SIZING_FAILED'),
              description: errorMessage,
            }
          });
        }
      });
    }
  });
  }

  /** Handles sort events from the table and resets pagination to the first page. */
  sortData(event): void {
    this.sort = event;
    this.pageIndex = 0;
  }

  /** Toggles sort order of filtered configurations by creation date (ascending/descending). */
  sortDateTime(): void {
    if(this.ascendingOrder){
      this.filteredConfigurations.sort((a,b) => a.dateCreated < b.dateCreated ? -1 : a.dateCreated > b.dateCreated ? 1 : 0);
      this.ascendingOrder = false;
    }else{
      this.filteredConfigurations.sort((a,b) => a.dateCreated < b.dateCreated ? 1 : a.dateCreated > b.dateCreated ? -1 : 0);
      this.ascendingOrder = true;
    }
    this.pageConfigurations = this.filteredConfigurations;
  }

  /** Default sort comparator that orders blueprint versions by creation date descending. */
  private defaultComparator(config1: BlueprintVersion, config2: BlueprintVersion): number {
    if (config1?.dateCreated && config2?.dateCreated) {
      return new Date(config2.dateCreated).getTime() - new Date(config1.dateCreated).getTime();
    }
    return 0;
  }

  /** Receives filtered search results from the environment-table child component and refreshes pagination. */
  searchedItems(searchResults: any[]): void {
    // Handle search results from the environment-table component
    this.filteredConfigurations = searchResults;
    this.pageIndex = 0; // Reset to first page on search
    this.updatePaginatedData();
  }

  /** Handles paginator page change events and updates the visible slice of data. */
  pageChanged(event: any): void {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
    this.updatePaginatedData();
  }

  /** Triggers a fresh reload of blueprint versions from the API. */
  refreshData(): void {
    this.dataLoading = true;
    this.loadBlueprintVersions();
  }

  /** Slices filteredConfigurations for the current page and maps each entry to the table row format. */
  updatePaginatedData(): void {
    const startIndex = this.pageIndex * this.paginationSize;
    const endIndex = startIndex + this.paginationSize;

    // Get the current page data from filteredConfigurations
    const pageConfigurations = this.filteredConfigurations?.slice(startIndex, endIndex) || [];

    // Map to tableData format
    this.paginatedTableData = pageConfigurations.map(blueprintVersion => ({
      ...blueprintVersion,
      version: String(blueprintVersion.version),
      status: this.getStatus(blueprintVersion),
      selected: this.selection?.id === blueprintVersion.id,
      arrowClick: false,
      disableSelection: Number(blueprintVersion.version) <= Number(this.deployedVersion)
    }));

    // Clear selection if not on current page
    if (this.selection && !pageConfigurations.find(config => config.id === this.selection.id)) {
      this.selection = null;
    }

    this.changeDetectorRef.detectChanges();
  }

  // Sizing view methods
  /** Switches between form and JSON view modes; triggers JSON data load when switching to JSON view. */
  switchView(view: SizingViewMode): void {
    this.currentView = view;
    if (view === SizingViewMode.JSON) {
      this.loadJsonView();
    }
  }

  /** Updates the sizing search term and applies filtering to the sizing cards list. */
  onSearchChanged(searchTerm: string): void {
    this.sizingSearchTerm = searchTerm;
    this.applySearch();
  }

  /** Serializes the current sizing cards to a formatted JSON string for display in the Monaco editor. */
  loadJsonView(): void {
    this.isJsonLoading = true;
    this.changeDetectorRef.detectChanges();

    setTimeout(() => {
      const jsonData = this.sizingCards.map(card => ({
        component: card.component,
        title: card.title,
        sections: card.sections
      }));
      this.jsonInput = {
        value: JSON.stringify(jsonData, null, 2),
        language: 'json'
      };
      this.isJsonLoading = false;
      this.changeDetectorRef.detectChanges();
    }, 300);
  }

  normalize(value: string): string {
  return value?.toLowerCase()
    .replace(/[_:\-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  }
 
  /** Filters sizing cards by the current search term across component name, title, section titles, and metric labels. */
  applySearch(): void {
  if (!this.sizingSearchTerm?.trim()) {
    this.sizingCards = [...this.originalSizingCards];
    this.changeDetectorRef.detectChanges();
    return;
  }
  const term = this.normalize(this.sizingSearchTerm);
  this.sizingCards = this.originalSizingCards
    .map(card => {
      if (this.normalize(card.component).includes(term) ||
        this.normalize(card.title || '').includes(term)) {
        return card;
      }
      const filteredSections = card.sections
        .map(section => {
          const sectionMatches = this.normalize(section.sectionTitle).includes(term);
          const filteredMetrics = section.metrics.filter(metric => {
            const combined = this.normalize(`${metric.label} ${metric.value}`);
            return combined.includes(term);
          });
          if (sectionMatches) return section;
          if (filteredMetrics.length > 0) return { ...section, metrics: filteredMetrics };
          return null;
        })
        .filter(Boolean);
      if (filteredSections.length > 0) return { ...card, sections: filteredSections };
      return null;
    })
    .filter(Boolean) as any[];
   this.changeDetectorRef.detectChanges();
  }

  /** Downloads the current sizing cards as a JSON file to the user's browser. */
  downloadJson(): void {
    const jsonData = this.sizingCards.map(card => ({
      component: card.component,
      title: card.title,
      sections: card.sections
    }));

    const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `sizing-document-${new Date().getTime()}.json`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  /**
       * Opens error dialog and handles retry/report actions after dialog closes
       * @param response
       */
      showErrorDialog(initial:boolean,response?:any,records?:any): void {
        if(initial) {
          const templateerror = SizingErrorUtil.groupTemplateErrors(response?.errors ?? []);
          const groupedErrors = SizingErrorUtil.groupErrorsByParent(templateerror);
          this.errorsWithComponent = groupedErrors.map((group: any) => ({...group,component: records[group.recordIndex]?.componentDisplayName  || records[group.recordIndex]?.component || ''}));
        }
        const errorDialogRef = this.matDialog.open(ErrorDialogComponent, {
          width: '566px',
          minHeight: '342px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('SIZING.VALIDATION_FAILED'),
            errorDetails : this.errorsWithComponent
          }
        });
        errorDialogRef.afterClosed().subscribe(result => {
          if (result === 'retry') {
            this.isSizingLoading = true;
            this.startSizingProcess();
          }
        });
      }

  /** Generates the next Sizing_Default name by incrementing the max major version found in existing names. */
  private generateNextSizingName(existingNames: string[]): string {
    const majors = existingNames
      .filter(n => /^sizing_default_v\d+\.\d+$/i.test(n))
      .map(n => parseInt(n.replace(/^sizing_default_v(\d+)\.\d+$/i, '$1'), 10));
    const max = majors.length > 0 ? Math.max(...majors) : 0;
    return `Sizing_Default_v${max + 1}.0`;
  }

  goBack(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_SERVICE_DEFINITION.CANCEL_UPDATE_TITLE'),
        message: translate('INSTANCE_DETAILS.UPDATE_SERVICE_DEFINITION.MESSAGE_SD'),
        confirmButtonText: translate('BUTTONS.YES'),
        cancelButtonText: translate('BUTTONS.NO')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.blueprint?.id]);
        }
      });
  }

  openContactForm(): void {
    const url = `https://itsm-servicedesk.temenos.com`;
    window.open(url, '_blank');
  }

}
